import React from 'react';
import './ReportReview.css';
import { Text } from '../../components/base/Text';
import { WarningOutlined } from '@ant-design/icons';
import { isNonEmpty } from '../../utils/arrayUtils';
import { Tooltip } from 'antd';
export const ReportAnomalies = ({ reportHighlights, setKBHighlights, setReportHighlights, showDescription = true, maxHeight, }) => {
    if (!isNonEmpty(reportHighlights)) {
        console.log('return 0 anomalies');
        return React.createElement(React.Fragment, null, `0 anomalies`);
    }
    return (React.createElement("div", null,
        React.createElement("div", { style: { textAlign: 'center', fontWeight: 700 } }, `${reportHighlights.length} anomal${reportHighlights.length > 1 ? 'ies' : 'y'}`),
        React.createElement("div", { style: {
                padding: 12,
                fontSize: 14,
                overflow: 'auto',
                maxHeight: maxHeight || 600,
            } }, reportHighlights.map((anomaly, index) => {
            return (React.createElement("div", { key: index, style: { marginTop: 14 } },
                React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-around', gap: 20 } },
                    React.createElement(Tooltip, { title: anomaly.description },
                        React.createElement(WarningOutlined, { className: "clickable", style: { color: 'red', fontSize: 16 }, onClick: () => {
                                setKBHighlights(anomaly.highlights);
                                if (setReportHighlights)
                                    setReportHighlights(anomaly.chunkToReviewHighlights);
                            } })),
                    showDescription ? (React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-around', gap: 20 } },
                        React.createElement("div", null, `${anomaly.description}`),
                        React.createElement(Text, { className: "clickable", value: "Source", style: { textDecoration: 'underline' }, onClick: () => {
                                setKBHighlights(anomaly.highlights);
                                if (setReportHighlights)
                                    setReportHighlights(anomaly.chunkToReviewHighlights);
                            } }))) : null)));
        }))));
};
